type PushSubscribePayload = {
    empresaId: string;
    usuarioId: string;
    subscription: PushSubscriptionJSON;
    clientOrigin?: string;
};

function urlBase64ToUint8Array(base64: string): Uint8Array {
    const padding = "=".repeat((4 - (base64.length % 4)) % 4);
    const base64Safe = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = window.atob(base64Safe);
    const outputArray = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; ++i) {
        outputArray[i] = raw.charCodeAt(i);
    }
    return outputArray;
}


async function initDashboardPush(empresaId: string, usuarioId: string): Promise<void> {
    if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) return;
    if (location.protocol !== "https:" && location.hostname !== "localhost") return;

    const already = localStorage.getItem("push_subscribed");
    if (already === "1") return;

    const reg = await navigator.serviceWorker.register("/sw.js");
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;

    const vapidResp = await fetch("/api/push/vapid-key", { credentials: "include" });
    const { publicKey } = await vapidResp.json();
    console.log("Push: Clave VAPID obtenida", publicKey);

    const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey) as any,
    });

    const body: PushSubscribePayload = {
        empresaId,
        usuarioId,
        subscription: sub.toJSON(),
        clientOrigin: window.location.origin,
    };

    console.log("Push: Enviando suscripción al servidor", body);

    const response = await fetch("/api/push/subscribe", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });

    if (response.ok) {
        localStorage.setItem("push_subscribed", "1");
        console.log("Push: ¡Suscripción registrada correctamente en la base de datos!");
    } else {
        console.error("Push: Error al registrar la suscripción en el servidor", await response.text());
    }
}

async function sendToUserFromDashboard(data: {
    empresaId: string;
    usuarioId: string;
    title: string;
    message: string;
    url?: string;
}) {
    await fetch("/api/push/send-user", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
}

// opcional: notificación local inmediata
function notifyLocal(title: string, body: string) {
    if (Notification.permission === "granted") {
        new Notification(title, { body });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const metaUser = document.querySelector('meta[name="push-usuario-id"]');
    const metaEmpresa = document.querySelector('meta[name="push-empresa-id"]');

    if (metaUser && metaEmpresa) {
        const usuarioId = metaUser.getAttribute('content');
        const empresaId = metaEmpresa.getAttribute('content');

        if (usuarioId && empresaId) {
            initDashboardPush(empresaId, usuarioId).catch(err => console.error("Error al inicializar Push:", err));
        }
    }
});
